import { getChatSession } from './getChatSession'
import { saveChatSession } from './saveChatSession'

/**
 * @param {LCChatUser} user
 */
export function saveChatUserToSession(user) {
  const session = getChatSession()
  if (!session.users.some((s) => s.id === user.id)) {
    session.users.push({
      avatar: user.avatar || '',
      id: user.id,
      name: user.name || '',
      type: user.type,
    })
  }
  saveChatSession(session)
}
